import { useTranslation } from 'react-i18next';
import { Scissors, Music, Sparkles, Download } from 'lucide-react';

export type MobileTab = 'edit' | 'media' | 'audio' | 'fx' | 'export';

interface MobileBottomTabBarProps {
  activeTab: MobileTab;
  onChange: (tab: MobileTab) => void;
}

const TABS: { id: MobileTab; labelKey: string; fallback: string; icon: typeof Scissors }[] = [
  { id: 'edit', labelKey: 'editor.mobile.edit', fallback: 'Edit', icon: Scissors },
  { id: 'media', labelKey: 'editor.media', fallback: 'Media', icon: Music },
  { id: 'audio', labelKey: 'editor.audio', fallback: 'Audio', icon: Music },
  { id: 'fx', labelKey: 'editor.effects', fallback: 'FX', icon: Sparkles },
  { id: 'export', labelKey: 'editor.export', fallback: 'Export', icon: Download },
];

export function MobileBottomTabBar({ activeTab, onChange }: MobileBottomTabBarProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex shrink-0 border-t border-[#2A2A2E] bg-[#0A0A0A]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
    >
      {TABS.map(({ id, labelKey, fallback, icon: Icon }) => {
        const isActive = activeTab === id;
        return (
          <button
            key={id}
            onClick={() => onChange(id)}
            className={`flex-1 flex flex-col items-center gap-0.5 py-2 transition-colors ${
              isActive
                ? 'text-[var(--user-page-accent)]'
                : 'text-[#8E8E93] hover:text-[var(--user-page-text)]'
            }`}
            role="tab"
            aria-selected={isActive}
          >
            <Icon size={18} />
            <span className="text-[10px] font-medium">{t(labelKey, fallback)}</span>
          </button>
        );
      })}
    </div>
  );
}
